import { useCallback, useEffect, useRef, useState } from 'react';

const CHARS = '0123456789ABCDEFabcdef!@#$%^&*><[]{}|\\/?;:';

function randomChar(actual) {
  return actual === ' ' ? ' ' : CHARS[Math.floor(Math.random() * CHARS.length)];
}

export function useScramble(text, trigger, cypherpunkMode) {
  const [displayed, setDisplayed] = useState(trigger === 'mount' ? '' : text);
  const intervalRef = useRef(null);
  const isScrambledRef = useRef(false);

  const scramble = useCallback((finalText, onDone) => {
    let frame = 0;
    const totalFrames = 20;
    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      frame++;
      const revealed = Math.floor((frame / totalFrames) * finalText.length);
      const result = finalText.split('').map((ch, i) => (i < revealed ? ch : randomChar(ch))).join('');
      setDisplayed(result);
      if (frame >= totalFrames) {
        clearInterval(intervalRef.current);
        setDisplayed(finalText);
        if (onDone) onDone();
      }
    }, 30);
  }, []);

  const fullScramble = useCallback((finalText) => {
    let frame = 0;
    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      frame++;
      const result = finalText.split('').map((ch) => randomChar(ch)).join('');
      setDisplayed(result);
      if (frame >= 8) clearInterval(intervalRef.current);
    }, 60);
  }, []);

  useEffect(() => {
    if (trigger !== 'mount') return undefined;
    const timer = setTimeout(() => scramble(text), 200);
    return () => { clearTimeout(timer); clearInterval(intervalRef.current); };
  }, [trigger, text, scramble]);

  useEffect(() => {
    if (cypherpunkMode && trigger !== 'mount') {
      fullScramble(text);
      isScrambledRef.current = true;
    } else if (!cypherpunkMode && isScrambledRef.current) {
      scramble(text);
      isScrambledRef.current = false;
    }
    return () => clearInterval(intervalRef.current);
  }, [cypherpunkMode, trigger, text, scramble, fullScramble]);

  const handleHover = () => {
    if (trigger === 'hover') scramble(text);
  };

  return { displayed, handleHover };
}
